import { BreakdownTabs } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownTabs';
import { BreakdownHeader } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownHeader';

export const MediumBreakdown = () => {
  return (
    <>
      <BreakdownHeader />
      <BreakdownTabs />
    </>
  );
};
